export const getCookieValue = (cookieName: string) => {
  const results = document.cookie.match(
    '(^|[^;]+)\\s*' + cookieName + '\\s*=\\s*([^;]+)'
  )
  return results ? results.pop() : undefined
}
